



























import { defineComponent, PropType } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "BaseTooltip",
  components: { BaseIconButton },
  props: {
    placement: { type: String as PropType<"left" | "right" | "center">, default: "center" },
    autoShowHint: { type: Boolean, default: false },
    hideIcon: { type: Boolean, default: false },
  },
  data() {
    return {
      showHint: this.autoShowHint,
    };
  },
  computed: {
    hasPointer() {
      return this.placement === "center";
    },
  },
  methods: {
    toggleShowHint() {
      this.showHint = !this.showHint;
      if (this.showHint) {
        window.addEventListener("resize", this.positionTooltip);
        window.addEventListener("scroll", this.positionTooltip);
        this.$nextTick(this.positionTooltip);
      } else {
        window.removeEventListener("resize", this.positionTooltip);
        window.removeEventListener("scroll", this.positionTooltip);
      }
    },
    onCloseButtonClick() {
      this.$emit("close");
      this.toggleShowHint();
    },
    positionTooltip() {
      const tooltip = this.$refs.tooltip as HTMLElement;
      const trigger = this.$refs.trigger as HTMLElement;
      if (!tooltip || !trigger) return;

      const SCREEN_PADDING = 16;
      const OFFSET = 16;

      const triggerRect = trigger.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const screenWidth = window.innerWidth;

      // 1. Вертикальное направление (вниз/вверх)
      const spaceBelow = window.innerHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;

      let top = triggerRect.bottom + OFFSET;
      if (spaceBelow < tooltipRect.height + OFFSET && spaceAbove > tooltipRect.height + OFFSET) {
        top = triggerRect.top - tooltipRect.height - OFFSET;
        tooltip.classList.add("__top");
      } else {
        tooltip.classList.remove("__top");
      }

      // 2. Горизонтальная позиция по placement
      let left = 0;

      if (this.placement === "left") {
        left = triggerRect.left;
      }
      if (this.placement === "right") {
        left = triggerRect.right - tooltipRect.width;
      }
      if (this.placement === "center") {
        left = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;
      }

      // 3. Сдвиг, чтобы не выходить за экран
      if (left < SCREEN_PADDING) left = SCREEN_PADDING;
      if (left + tooltipRect.width > screenWidth - SCREEN_PADDING) {
        left = screenWidth - SCREEN_PADDING - tooltipRect.width;
      }

      // 4. Если не помещается — уменьшаем ширину
      const maxWidth = screenWidth - SCREEN_PADDING - left;
      if (tooltipRect.width > maxWidth) {
        tooltip.style.width = `${maxWidth}px`;
      }

      tooltip.style.top = `${top}px`;
      tooltip.style.left = `${left}px`;

      if (this.hasPointer) {
        this.$nextTick(() => {
          const tooltipRect = tooltip.getBoundingClientRect();
          const triggerCenter = triggerRect.left + triggerRect.width / 2 - tooltipRect.left;
          tooltip.style.setProperty("--trigger-center", `${triggerCenter}px`);
        });
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.positionTooltip);
    window.removeEventListener("scroll", this.positionTooltip);
  },
});
